// Reusable clickable table header for sortable columns.
//
//   <SortHeader col="business_date" sortBy={sortBy} sortDir={sortDir} onClick={onSort}>
//     Date
//   </SortHeader>
//
// Active column gets a crisp white arrow + an orange underline. The underline
// is an inset shadow rather than a border: `border-collapse: collapse` hands
// border painting to the table, which drops it on a sticky (frozen) header.
export function SortHeader({ col, sortBy, sortDir, onClick, children, style }) {
  const active = sortBy === col;
  const arrow = !active ? '↕' : sortDir === 'asc' ? '↑' : '↓';
  // Frozen columns pass their own divider shadow — keep both.
  const shadows = [style?.boxShadow, active ? 'inset 0 -2px 0 #FF6600' : null].filter(Boolean);
  return (
    <th
      onClick={() => onClick(col)}
      title={`Sort by ${col}`}
      style={{
        cursor: 'pointer',
        userSelect: 'none',
        ...(style || {}),
        ...(shadows.length ? { boxShadow: shadows.join(', ') } : {}),
      }}
    >
      {children}{' '}
      <span
        style={{
          color: active ? '#fff' : 'rgba(255,255,255,0.55)',
          fontSize: 11,
          fontWeight: active ? 700 : 400,
        }}
      >
        {arrow}
      </span>
    </th>
  );
}

// Numeric/date columns prefer DESC on first click; strings prefer ASC.
const NUMERICISH = /(count|punches|hours|amount|_id|threshold|sites_used)$/i;

export function initialSortDirFor(col) {
  if (!col) return 'asc';
  return NUMERICISH.test(col) ? 'desc' : 'asc';
}
